import Backdrop from '@mui/material/Backdrop'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from './components/Tooltip/Tooltip'
import { PriaTourStep } from './PriaTourStep'
import { TourSpotlight } from './TourSpotlight'

export const PriaTour = ({ showTour = false, setShowTour = () => { }, steps = [], spotlight = false }) => {
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = useState(null)
  const [currentStep, setCurrentStep] = useState(0)

  const isLastStep = currentStep === steps.length - 1

  const handleNextStep = () => {
    steps[currentStep]?.beforeNext?.()
    if (isLastStep) {
      // localStorage.setItem(dsarTourLocalStorageKey, 'finished')
      setShowTour(false)
    }
    setAnchorEl(null)
    setCurrentStep((prev) => prev + 1)
  }

  useEffect(() => {
    const targetElement = document.getElementById(steps[currentStep]?.targetId)
    if (targetElement) {
      setAnchorEl(targetElement)
    }
  }, [showTour, currentStep, steps])

  return (
    <>
      {spotlight
        ? <TourSpotlight targetElement={anchorEl} show={showTour} />
        : <Backdrop open={showTour} sx={({ zIndex }) => ({ zIndex: zIndex.tooltip - 1 })} />
      }
      {anchorEl && (
        <Tooltip
          maxWidth={504}
          open={!!anchorEl && showTour}
          PopperProps={{ anchorEl }}
          title={
            <PriaTourStep
              title={steps[currentStep].title}
              description={steps[currentStep].description}
              onNext={handleNextStep}
              actionButtonLabel={steps[currentStep].actionButtonLabel ?? t('label.next')}
              index={currentStep + 1}
              total={steps.length}
              showProgress={steps[currentStep].showProgress ?? true}
            />
          }
          arrow
          placement={steps[currentStep].placement}
          enterDelay={1000}
        >
          <div />
        </Tooltip>
      )}
    </>
  )
}
